import { Component, computed, input } from '@angular/core';
import { ChipSize, ChipThemeColor, KENDO_CHIP } from '@progress/kendo-angular-buttons';
import { UnityWorkflowState } from '@unity/clients';
@Component({
  selector: 'unity-chip-workflow-state-shared',
  standalone: true,
  imports: [KENDO_CHIP],
  templateUrl: './chip-workflow-state-shared.component.html',
  styleUrl: './chip-workflow-state-shared.component.scss',
})
export class ChipWorkflowStateSharedComponent {
  public readonly $name = input.required<string>({ alias: 'name' });
  public readonly $value = input.required<UnityWorkflowState>({ alias: 'value' });

  public readonly $color = input<ChipThemeColor>(undefined, { alias: 'color' });
  public readonly $size = input<ChipSize>('medium', { alias: 'size' });

  protected readonly $themeColor = computed(() => {
    const color = this.$color();
    const value = this.$value();
    if (color) {
      return color;
    }

    switch (value) {
      case UnityWorkflowState.Active:
      case UnityWorkflowState.Approved:
      case UnityWorkflowState.Paid:
        return 'success';
      case UnityWorkflowState.Rejected:
      case UnityWorkflowState.Disabled:
        return 'error';
      case UnityWorkflowState.ChangeRequested:
      case UnityWorkflowState.Refunded:
      case UnityWorkflowState.Duplicate:
        return 'warning';
      case UnityWorkflowState.Draft:
      case UnityWorkflowState.Canceled:
      case UnityWorkflowState.Completed:
      case UnityWorkflowState.PendingApproval:
      case UnityWorkflowState.PendingDirectorApproval:
      case UnityWorkflowState.Planned:
      case UnityWorkflowState.Archived:
      case UnityWorkflowState.Exited:
      case UnityWorkflowState.Unknown:
        return 'base';
      default:
        return 'none';
    }
  });
}
